const REJECT_CODES = new Set([4001, '4001', 'ACTION_REJECTED']);

export function isUserRejection(error) {
  if (!error) return false;
  if (REJECT_CODES.has(error.code)) return true;
  const msg = (error.message || '').toLowerCase();
  return (
    msg.includes('user denied') ||
    msg.includes('user rejected') ||
    msg.includes('rejected the request') ||
    msg.includes('action_rejected')
  );
}

export function parseTxError(error, fallback = 'Transaction failed') {
  if (!error) return fallback;

  if (isUserRejection(error)) {
    return 'Transaction cancelled — you rejected it in your wallet.';
  }

  const msg = error.message || '';

  if (msg.includes('insufficient funds')) {
    return 'Insufficient ETH for gas fees. Add a small amount of ETH to your wallet on Base.';
  }

  if (msg.includes('gas limit') || msg.includes('exceeds maximum')) {
    return 'Gas estimation failed. Please try again — if it persists, check you have ETH for gas on Base.';
  }

  // Extract Solidity revert reason from common web3 error shapes
  const revertMatch =
    msg.match(/reverted with reason string '([^']+)'/) ||
    msg.match(/revert\s+(.+?)(?:\n|$)/i) ||
    msg.match(/ADBYTESStaking: ([^"'\n]+)/) ||
    msg.match(/StakedADBYTES: ([^"'\n]+)/) ||
    msg.match(/ERC20: ([^"'\n]+)/);

  if (revertMatch) {
    return revertMatch[1].trim();
  }

  if (msg.includes('insufficient reward treasury')) {
    return 'Reward treasury is empty. Harvest/restake will work once the pool is funded.';
  }

  if (msg.includes('no rewards')) {
    return 'No rewards available to claim right now.';
  }

  if (msg.includes('active unstake request')) {
    return 'You already have an active unstake request. Complete or clear it first.';
  }

  if (msg.includes('cooldown active')) {
    return 'Cooldown still active. Wait for the timer to finish before completing unstake.';
  }

  if (msg.includes('claim window expired')) {
    return 'Claim window expired. Use "Return to Wallet" to get your stADBYTES back.';
  }

  if (msg.length > 120) {
    return fallback;
  }

  return msg || fallback;
}
